import i18n from '../i18n'
import { UI_LANGUAGE_CODES } from '../constants/uiLanguages'

/** Apply child account preferred UI language after login (server source of truth). */
export function applyPreferredLanguageFromProfile(profile) {
  const lng = profile?.child?.preferred_language
  if (!lng || !UI_LANGUAGE_CODES.includes(lng)) return Promise.resolve()
  return i18n.changeLanguage(lng).then(() => {
    try {
      window.localStorage.setItem('i18nextLng', lng)
    } catch {
      /* ignore */
    }
    const short = lng.split('-')[0].toLowerCase()
    document.documentElement.lang = short
    document.documentElement.dir = ['fa', 'ar'].includes(short) ? 'rtl' : 'ltr'
  })
}
